import type { CardContentKind } from "@-/dev.improve.haniverse.lib.cards.card-content";

export type MorphemeSelectionItem = {
  front: string;
  kind: "morpheme";
};

export type UserCardSelectionItem = {
  contentKind: CardContentKind;
  front: string;
  kind: "user-card";
  userCardId: string;
};

/** One independently selectable item in the app-wide morpheme/card selection mode. */
export type AppSelectionItem = MorphemeSelectionItem | UserCardSelectionItem;

export type AppSelectionScope = AppSelectionItem["kind"];

/** Stable identity used by the app-layout selection map. */
export function appSelectionItemKey(item: AppSelectionItem): string {
  return item.kind === "morpheme" ? `morpheme:${item.front}` : `user-card:${item.userCardId}`;
}

export function morphemeSelectionItem(front: string): MorphemeSelectionItem {
  return { front, kind: "morpheme" };
}

export function userCardSelectionItem({
  contentKind,
  front,
  userCardId,
}: Omit<UserCardSelectionItem, "kind">): UserCardSelectionItem {
  return { contentKind, front, kind: "user-card", userCardId };
}
